import cn from 'classnames';

import OPE from 'js/on-page-editing';
import { EducationBlock_EditorThemeMap, getEnumStringValue } from 'js/utils/enum-string-maps';

import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';
import Link from 'components/link/Link';
import Icon from 'components/icon/Icon';

import { IEducationBlock } from 'source/NFR.types';

const EducationBlock: React.FC<IEducationBlock> = ({
  link,
  editorTheme,
  image,
  onPageEditing,
  title,
  grade,
  time,
  imageLeft,
  ingress
}) => (
  <div
    className={cn('education-block', getEnumStringValue(EducationBlock_EditorThemeMap, editorTheme), {
      'education-block--reverse-order': imageLeft
    })}
  >
    <div className="education-block--text">
      {(grade || time) && (
        <span className="education-block--info">
          {grade && <span {...OPE(onPageEditing?.grade)}>{grade}</span>}
          {grade && time && '|'}
          {time && (
            <span className="education-block--time" {...OPE(onPageEditing?.time)}>
              <Icon name="clock" fill className="education-block--clock" />
              {time}
            </span>
          )}
        </span>
      )}

      {title && (
        <h2 className="education-block--title" {...OPE(onPageEditing?.title)}>
          {title}
        </h2>
      )}
      {ingress && (
        <p className="education-block--ingress" {...OPE(onPageEditing?.ingress)}>
          {ingress}
        </p>
      )}
      {link && <Link className="education-block--link" theme="primary" useButtonStyles {...link} />}
    </div>
    {image && (
      <div className="education-block--image">
        <Image {...imageSizes.educationBlock} {...image} />
      </div>
    )}
  </div>
);

EducationBlock.displayName = 'EducationBlock';

export default EducationBlock;
